/* eslint-disable react-hooks/exhaustive-deps */
import ItemLocation from '@components/ItemLocation';
import React, { memo, useCallback, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { SLIDER_CONFIG_SUGGESTION_LOCATION } from './constants';
import { PostSceneWrapper } from './styled';
import { useSelector } from 'react-redux';

import {
  selectDetailProject,
  selectSceneSelected,
} from '@containers/Home/selectors';
import useNavigateBetweenProject from '@containers/Home/hook/useNavigateBetweenProject';
import { useCommentGoterest } from '@containers/Home/hook/useCommentGoterest';
import dynamic from 'next/dynamic';
import {
  useFeatureCommentGoterest,
  useTourEventState,
} from '@containers/Home/global/TourStats';
import { useGetDetailPost } from '@containers/Home/hook/useGetDetailPost';
import { useKrpano } from '@containers/Home/hook/useKrpano';
import { useMediaQuery } from 'react-responsive';

const Comments = dynamic(() => import('./Comments'));
const LoadingContainer = dynamic(() => import('@components/LoadingContainer'));
const ModalShare = dynamic(() => import('@components/ModalShare'), {
  ssr: false,
});

interface Props {
  isShowIntro: boolean;
}

const PostScene = memo(({ isShowIntro }: Props) => {
  const sceneSelected = useSelector(selectSceneSelected);
  const projectSelected = useSelector(selectDetailProject);
  const isMobi = useMediaQuery({
    query: '(max-width: 640px)',
  });
  const [showCardInfo, setShowCardInfo] = useState(!isMobi ? true : false);
  const [scrollSlide, setscrollSlide] = useState(false);

  const [isVisibleModalShare, setIsVisibleModalShare] = useState(false);
  const [isShowPanelComments, setIsShowPanelComments] = useState(false);

  const { listCommentGoterestSelected } = useCommentGoterest();
  const [loading] = useFeatureCommentGoterest('loading');
  const { onChangeProject } = useNavigateBetweenProject();

  const [tourEventState, setTourEventState] = useTourEventState('state');

  const { onToggleInfoScene } = useKrpano({});

  const { detailPost } = useGetDetailPost({
    idPost: tourEventState.idPostSceneSelected,
  });

  const onOpenModalShare = () => setIsVisibleModalShare(true);
  const onCloseModalShare = useCallback(
    () => setIsVisibleModalShare(false),
    [],
  );

  const onToggleShowPanelComments = useCallback((isShow: boolean) => {
    setIsShowPanelComments(isShow);
  }, []);

  const handleCardInfo = useCallback(e => {
    setShowCardInfo(e);
  }, []);

  useEffect(() => {
    if (isMobi && isShowIntro) setShowCardInfo(false);
  }, [isShowIntro]);
  useEffect(() => {
    if (sceneSelected?.post) onToggleInfoScene(true);
    else {
      onToggleInfoScene(false);
      setTourEventState(prev => ({ ...prev, idPostSceneSelected: '' }));
    }
    return () => {
      onToggleInfoScene(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sceneSelected]);

  return (
    <>
      <PostSceneWrapper
        className={`cards-info ${showCardInfo === true ? '' : 'active'}`}
        id="themePostScene"
      >
        <div className="cards-header">
          <div className="--title-cards">
            {projectSelected?.place?.iconPopup?.default && (
              <div className="--icon">
                <img
                  src={
                    projectSelected?.place?.iconPopup?.thumbnail_640_jpg ||
                    projectSelected?.place?.iconPopup?.thumbnail_720_jpg ||
                    projectSelected?.place?.iconPopup?.default
                  }
                  alt=""
                />
              </div>
            )}
            <h6 className="mb-0">
              {projectSelected?.place?.name || 'Flycam' || 'N/A'}
            </h6>
          </div>
          <div className="--close" onClick={() => handleCardInfo(false)}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <LoadingContainer loading={loading}>
          <div className="cards-body">
            {isShowPanelComments === false ? (
              <div className="infoAddress ">
                <h5 className="--title">{projectSelected?.location?.name}</h5>
                <div className="--view">
                  {sceneSelected?.view_count || 0} lượt xem
                </div>

                <article
                  className="--des"
                  id="desCard"
                  dangerouslySetInnerHTML={{
                    __html:
                      projectSelected?.location?.description ||
                      detailPost?.content ||
                      '',
                  }}
                />
                <div className="interact">
                  <a className="--item" onClick={() => onOpenModalShare()}>
                    <i className="fa-solid fa-share-nodes"></i>
                    <span>chia sẻ</span>
                  </a>
                  <div
                    className="--item"
                    onClick={() => onToggleShowPanelComments(true)}
                  >
                    <i className="fa-regular fa-comment"></i>{' '}
                    <span>{listCommentGoterestSelected.length}</span>
                  </div>
                </div>
                {!!projectSelected?.location?.suggestion?.length && (
                  <div className="--number">
                    Xem thêm ({projectSelected?.location?.suggestion?.length})
                  </div>
                )}
                <div className="--listLocation">
                  <Slider
                    {...SLIDER_CONFIG_SUGGESTION_LOCATION}
                    beforeChange={() => {
                      setscrollSlide(true);
                    }}
                    afterChange={() => {
                      setscrollSlide(false);
                    }}
                  >
                    {projectSelected?.location?.suggestion?.map(item => (
                      <ItemLocation
                        key={item.id}
                        img={item?.locationImage?.thumbnail_720_jpg}
                        name={item?.name}
                        numberImg={item.numberImageTour}
                        onClick={() =>
                          !scrollSlide && onChangeProject(item.projectId?.slug)
                        }
                        // link={item?.link}
                      />
                    ))}
                  </Slider>
                </div>
              </div>
            ) : (
              <Comments onToggleShowPanelComments={onToggleShowPanelComments} />
            )}
          </div>
        </LoadingContainer>

        {isVisibleModalShare && (
          <ModalShare
            isVisible={isVisibleModalShare}
            onCancel={onCloseModalShare}
          />
        )}
      </PostSceneWrapper>
      <div
        className={`showCardInfo ${showCardInfo === true ? '' : 'active'}`}
        onClick={() => handleCardInfo(true)}
      >
        Giới thiệu <i className="fa-solid fa-angle-up"></i>
      </div>
    </>
  );
});

export default PostScene;
